import Logo from './badge.svg';
import { component } from './styles.module.scss';

const Badge = () => (
  <div className={component}>
    <Logo />
  </div>
);

export default Badge;
